import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import Paper from "@material-ui/core/Paper";
import { TextField } from "@material-ui/core";

export default function ChangePassword(props) {
  const [open, setOpen] = React.useState(false);
  const saveNewPassword = props.saveNewPassword;
  const [values, setValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmedPassword: "",
  });

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const submit = (e) => {
    e.preventDefault();
    saveNewPassword(
      e,
      values.currentPassword,
      values.newPassword,
      values.confirmedPassword
    );
    setValues({
      currentPassword: "",
      newPassword: "",
      confirmedPassword: "",
    });
    setOpen(false);
  };
  return (
    <Box zIndex="10" position="absolute" top="-25px" right="25px">
      <p
        style={{
          color: "#6c757d",
          cursor: "pointer",
          width: "15ch",
          marginLeft: "auto",
        }}
        size="medium"
        disabled={open}
        variant="outlined"
        onClick={() => {
          setOpen(true);
        }}
      >
        Change Password
      </p>
      <Collapse style={{ position: "relative" }} in={open}>
        <Paper style={{ padding: "5px", display: "flex" }}>
          <form onSubmit={(e) => submit(e)}>
            <h4>Update password</h4>
            <Box
              height="320px"
              width="300px"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <TextField
                type="password"
                name="currentPassword"
                label="Current password"
                value={values.currentPassword}
                onChange={onChange}
                className="form-control"
                placeholder="Password"
                style={{ background: "" }}
                required
              />
              <TextField
                type="password"
                name="newPassword"
                label="New password"
                value={values.newPassword}
                onChange={onChange}
                className="form-control"
                placeholder="Password"
                style={{ padding: 0 }}
                required
              />
              <TextField
                type="password"
                name="confirmedPassword"
                label="Confirm password"
                value={values.confirmedPassword}
                onChange={onChange}
                className="form-control"
                placeholder="Password"
                style={{
                  margin: "0px 5px",
                  backgroundColor: "#FAFAFA",
                }}
                required
              />
              <Button
                type="submit"
                color="primary"
                variant="contained"
                style={{ margin: "0px 0px" }}
              >
                Save
              </Button>
            </Box>
          </form>

          <IconButton
            style={{ position: "absolute", top: "5px", right: "2px" }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Paper>
      </Collapse>
    </Box>
  );
}

/*
const ChangePassword = (props) => {
  const saveNewPassword = props.saveNewPassword;
  const [values, setValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmedPassword: "",
  });

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const submit = (e) => {
    e.preventDefault();
    saveNewPassword(
      e,
      values.currentPassword,
      values.newPassword,
      values.confirmedPassword
    );
    setValues({
      currentPassword: "",
      newPassword: "",
      confirmedPassword: "",
    });
  };

  return (
    <div>
      <form
        onSubmit={
          (e) => submit(e)          
        }
      >
        <h4>Update password</h4>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "400px",
          }}
        >
          <TextField
            type="password"
            name="currentPassword"
            label="Current password"
            value={values.currentPassword}
            onChange={onChange}
            className="form-control"
            placeholder="Password"
            style={{ margin: "0px 5px", backgroundColor: "#FAFAFA" }}
            required
          />
          <TextField
            type="password"
            name="newPassword"
            label="New password"
            value={values.newPassword}
            onChange={onChange}
            className="form-control"
            placeholder="Password"
            style={{ margin: "0px 5px", backgroundColor: "#FAFAFA" }}
            required
          />
          <TextField
            type="password"
            name="confirmedPassword"
            label="Confirm password"
            value={values.confirmedPassword}
            onChange={onChange}
            className="form-control"
            placeholder="Password"
            style={{
              margin: "0px 5px",
              backgroundColor: "#FAFAFA",
            }}
            required
          />
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={{ margin: "0px 0px" }}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};
*/
